export default {
  resourcesInCategory: 'Resources in this category',
  resourcesDescription: 'Browse all resources within this category'
};
